import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import imgDropDown from '../../images/common/arrow_drop_down_black_24dp.svg';
import imgDropUp from '../../images/common/arrow_drop_up_black_24dp.svg';
import '../../styles/main.css';
import ColorSF2 from '../../styles/common/ColorSF2';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;
const SelectBoxWrapper = styled.div`
  position: relative;
`;
const Select = styled.input`
  width: 200px;
  padding-right: 24px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const DropDownImage = styled.img`
  position: absolute;
  left: 175px;
  top: -2px;
  cursor: pointer;
`;
const Selections = styled.div`
  position: absolute;
  max-height: 156px;
  overflow-y: auto;
  z-index: 1;
  border: 1px solid ${ColorSF2.mediumGray};
`;
const SelectOption = styled.div`
  width: 200px;
  background-color: ${props => (props.selected ? '#0085f2' : '#fff')};
  color: ${props => (props.selected ? '#fff' : '#000')};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const ClearButton = styled.div`
  margin-left: 8px;
  width: 48px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid ${ColorSF2.mediumGray};
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
`;
const MultipleSelectBox = ({ list, onSelect, clearId }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const defaultName = formatMessage({ id: 'common.label.noSelect' });
  const [showSetDialog, setShowSetDialog] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selectedNames, setSelectedNames] = useState('');
  useEffect(() => {
    setSelectedNames(selected.map(index => list[index]));
  }, [list, selected]);

  const clickSelectOption = targetIdx => {
    if (selected.some(idx => idx === targetIdx)) {
      // 選択肢から外す
      setSelected(selected.filter(idx => idx !== targetIdx));
    } else {
      // 選択肢に追加する
      const work = selected.slice();
      work.push(targetIdx);
      setSelected(work);
    }
  };
  const clickSelectBox = () => {
    if (showSetDialog) {
      // 閉じるときに検索条件として保存する
      onSelect(selected);
    }
    setShowSetDialog(!showSetDialog);
  };
  const clearSelected = () => {
    setSelected([]);
    onSelect([]);
  };
  return (
    <Wrapper>
      <SelectBoxWrapper onClick={() => clickSelectBox()}>
        <Select
          id="SelectBox"
          type="text"
          value={(selectedNames.length > 0 && selectedNames) || defaultName}
          readOnly
        />
        <DropDownImage
          src={(showSetDialog && imgDropUp) || imgDropDown}
          alt=""
        />
        {showSetDialog && (
          <Selections onClick={e => e.stopPropagation()}>
            {list &&
              list.map((name, idx) => {
                const selectedOption = selected.includes(idx);
                const uniqueKey = `${name}-${idx}`;
                return (
                  <SelectOption
                    selected={selectedOption}
                    className="clickableSelectOptions"
                    value={name}
                    key={uniqueKey}
                    onClick={() => clickSelectOption(idx)}
                  >
                    {name}
                  </SelectOption>
                );
              })}
          </Selections>
        )}
      </SelectBoxWrapper>
      <ClearButton
        className="button"
        id={clearId || 'clearButton'}
        role="presentation"
        onClick={() => clearSelected()}
      >
        <FormattedMessage id="common.button.clear" />
      </ClearButton>
    </Wrapper>
  );
};

MultipleSelectBox.propTypes = {
  list: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  clearId: PropTypes.string,
};

MultipleSelectBox.defaultProps = {
  clearId: '',
};

export default MultipleSelectBox;
